<template>
  <div class="bananerAdv">
    <div class="swiper" v-if="bannerPicGroup.length!=0&&location">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in bannerPicGroup" :key="index" >
          <img :src="item+'?imageView2/1/w/720/h/160/q80/format/webp&x-oss-process=image/resize,m_fill,w_710,h_160'" @click="goPage(link[index])" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var config = {};
import api from "@/utils/api";
import { getStorage } from "@/utils/wxuser";
import Swiper from "swiper";
export default {
  name: "bannerSwiper",
  data() {
    return {
      swiper:null,
      bannerPicGroup: [],
      link: [],
      user: getStorage("user")
    }
  },

  props: {
    location: {
      tyep: String,
      default: "hotelGroup_mall_active"
    },
    hotelCode: {
      tyep: String
    }
  },
  methods: {
   
    initSwiper() {
      this.swiper = new Swiper(".swiper", {
        autoplay: true,
        paginationClickable: true,
        autoplayDisableOnInteraction: true, // 处理手动滑动后，继续自动滑动
        loop: this.bannerPicGroup.length > 1,
        observer: true,
        observeParents: true
      });
    },
    getScrollPic() {
      api
        .getScrollPic({
          hotelGroupCode: config.hotelGroupCode,
          location: this.location,
          hotelCode: this.hotelCode||config.hotelCode,
          linkType: config.linkType,
          appid:config.appid
        })
        .then(res => {
          // console.log(res)
          if (res.result == 1) {
            if (res.retVal.picUrl) {
              this.bannerPicGroup = res.retVal.picUrl.split(",");
              this.link = res.retVal.link.split(",");
              var link = this.link
              link.forEach((item, i) => {
                var cardLevel = this.getQueryVariable(item, 'cardLevel')
                if (cardLevel && this.scrollType != '3') {
                  var allow = false
                  var cardLevels = cardLevel.split('|')

                  cardLevels.forEach((item) => {
                    if (this.user.cardLevel && item == this.user.cardLevel) {
                      allow = true
                    }
                  })
                  if (!allow) {
                    this.link.splice(i, 1)
                    this.bannerPicGroup.splice(i, 1)
                  }
                }
              })
              this.$nextTick(() => {
                this.initSwiper();
              });
            }
          }
        });
    },
    goPage(url) {
      if(url){
        window.location.href = url
      }
      
    }
  },
  created() {
    config = getStorage("config");
    if (this.$route.query.belongHotelCode) {
      this.hotelCode = this.$route.query.belongHotelCode
    }
  },
  computed: {},
  mounted() {
    this.$nextTick(() => {
      this.getScrollPic();
    });
  }
};
</script>

<style lang="less" scoped>
.bananerAdv {
  width: 100%;
  .swiper {
    width: 100%;
    position: relative;
    .swiper-wrapper {
      position: relative;
      width: 100%;

      .swiper-slide {
        width: 100%;
        height: 2.133333rem;
        padding: 0 0.266667rem;
        box-sizing: border-box;
        overflow: hidden;
        transform: translate3d(0, 0, 0);
        img {
          // border-radius: 1.066667rem;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bananerAdv.vue